import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Delay tracking to not block page render
    const timer = setTimeout(() => {
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      // Use sendBeacon for non-blocking request, fallback to fetch
      const data = JSON.stringify({ page: location.pathname, referrer: document.referrer || null });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(`${backendUrl}/api/track`, new Blob([data], { type: 'application/json' }));
      } else {
        fetch(`${backendUrl}/api/track`, { method: 'POST', body: data, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
      }
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return null;
};

export default PageTracker;
